import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {Title} from '@angular/platform-browser';
import {Browser} from '@capacitor/browser';

import {Events} from './events.service';
import {LocalDataService} from './local-data.service';
import {PlatformService} from './platform.service';

import {AppUtils} from '../app.utils';

import {environment} from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class NavigationService {

	constructor(private router: Router, private location: Location, private events: Events, private localDataService: LocalDataService, private platformService: PlatformService, private titleService: Title) {
	}

	async goToInternal(page, params?) {
		try {
			this.pageSelected(page, params);
			await this.router.navigate([page], {queryParams: params});
		} catch (error) {
			throw 'NOT_FOUND';
		}
	}

	async goBack() {
		this.location.back();
		await AppUtils.delay(100);
		const url = this.router.url.split('?')[0];
		this.pageSelected(url, this.getParamsFromUrl(this.router.url));
	}

	pageSelected(url, params?) {
		let pageId = null;
		let title = 'Atmosphère';
		switch (url) {
			case '/home':
				pageId = 0;
				title = 'Accueil';
				break;
			case '/conventions/new':
				pageId = 1;
				title = 'Nouvelle convention';
				break;
			case '/conventions':
				pageId = 2;
				title = 'Conventions';
				break;
			case '/suivi-conventions':
				switch (params?.viewType) {
					case 'suiviActivite' :
						pageId = 3;
						title = 'Suivi d\'activité';
					break;
					case 'tempsPasse' :
						pageId = 4;
						title = 'Temps passé';
						break;
				}
				break;
			case '/planning':
				pageId = 5;
				title = 'Planning projets';
				break;
			case '/indicateurs':
				switch (params?.viewType) {
					case 'suiviAdherents' :
						pageId = 7;
						title = 'Suivi des adhérents';
						break;
					case 'suiviConventions' :
						pageId = 8;
						title = 'Suivi des conventions';
						break;
					case 'suiviChiffreAffaires' :
						pageId = 9;
						title = 'Suivi du chiffre d\'affaires';
						break;
					case 'suiviFacturation' :
						pageId = 10;
						title = 'Suivi de la facturation';
						break;
					case 'suiviReste' :
						pageId = 16;
						title = 'Suivi du reste à réaliser';
						break;
				}
				break;
			case '/marches/new':
				pageId = 11;
				title = 'Nouveau marché';
				break;
			case '/marches':
				pageId = 12;
				title = 'Marchés';
				break;
			case '/feuilles-heures/new':
				pageId = 13;
				title = 'Nouvelle feuille d\'heures';
				break;
			case '/feuilles-heures':
				switch (params?.viewType) {
					case 'liste' :
						pageId = 14;
						title = 'Feuilles d\'heures';
						break;
					case 'analyse' :
						pageId = 15;
						title = 'Analyse temps passé';
						break;
				}
				break;
		}
		if (url !== '/conventions/new' && url.includes('/conventions/')) {
			pageId = 2;
			title = url.substring(13, url.length);
		}
		if (url !== '/marches/new' && url.includes('/marches/')) {
			pageId = 12;
			title = url.substring(9, url.length);
		}
		if (url !== '/feuilles-heures/new' && url.includes('/feuilles-heures/')) {
			pageId = 14;
			title = 'Feuille d\'heures';
		}
		this.events.publish('pageSelected', pageId);
		this.titleService.setTitle(title);
	}

	getParamsFromUrl(url) {
		let params: any = url.split('?')[1];
		const paramsFormatted = [];
		if (params) {
			params = params.split('&');
			for (const i in params) {
				const curParam = params[i].split('=');
				if (curParam[0] && curParam[1]) {
					paramsFormatted[curParam[0]] = curParam[1];
				}
			}
		}
		return paramsFormatted;
	}

	async goToExternal(page, connected = true) {
		let url;
		if (connected) {
			url =  environment.external_url_redirect;
			url += '?uri=' + encodeURIComponent(page);
			const token = await this.localDataService.getItem('token');
			if (token) {
				url += '&key=' + token;
			}
		} else {
			url =  environment.external_url + page;
		}
		await Browser.open({url: url, windowName: '_blank'});
	}

	async composeEmail(to, cc, subject, body) {
		if (this.platformService.isDesktop) {
			let url = '';
			if (to) {
				url += 'mailto:' + to;
			} else {
				url += 'mailto:';
			}
			url += '?subject=' + subject + '&';
			if (cc.length > 0) {
				url += 'cc=' + cc.join(';') + '&';
			}
			url += 'body=' + body;
			await Browser.open({url: encodeURI(url), windowName: '_system'});
		}
	}
}
